import { render, staticRenderFns } from "./GrammarTips.vue?vue&type=template&id=5efdbf45&scoped=true&"
import script from "./GrammarTips.vue?vue&type=script&lang=js&"
export * from "./GrammarTips.vue?vue&type=script&lang=js&"
import style0 from "./GrammarTips.vue?vue&type=style&index=0&id=5efdbf45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdbf45",
  null
  
)

export default component.exports